import { useTranslation } from 'react-i18next';
import { useSessionStore } from '@/entities/session/model/sessionStore';
import { useThemeStore, isDarkChromeTheme } from '@/entities/session/model/themeStore';
import { BrandWordmark } from '@/shared/ui';
import { ThemeSwitcher } from '@/widgets/theme-switcher/ThemeSwitcher';

export function Header() {
  const { t } = useTranslation();
  const currentContext = useSessionStore((s) => s.currentContext);
  const theme = useThemeStore((s) => s.theme);

  return (
    <header
      className="header-glass sticky top-0 z-40 flex h-16 items-center justify-between border-b border-border px-6 transition-colors"
      style={{ background: 'var(--t-header-bg)' }}
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <div className="flex shrink-0 items-center">
            <BrandWordmark
              to="/app"
              heightClass="h-7 sm:h-8"
              onDarkSurface={isDarkChromeTheme(theme)}
              showText={false}
            />
          </div>
        </div>
        {currentContext && (
          <span className="rounded-md bg-primary-100 px-2 py-0.5 text-sm text-primary-700">
            {currentContext.name}
          </span>
        )}
      </div>

      <div className="flex items-center gap-3">
        <div
          className="gradient-emerald-gold flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold text-white shadow-emerald"
          title={t('header.aiBadge')}
        >
          {t('header.aiBadge')}
        </div>
        <ThemeSwitcher compact />
      </div>
    </header>
  );
}
